import type { Component, Page } from "../../types";

export interface VersioningEditorState {
  pages: Page[];
  pageComponents: Map<string, Component[]>;
  projectId: string | null;
}

type VersioningEditorSource = () => VersioningEditorState;

// Kept in a separate file to break the circular runtime import:
//   editor-store.ts -> canvas-slice.ts -> versioning-integration.ts -> (here)
// Do not merge into editor-store.ts.
let versioningEditorSource: VersioningEditorSource | null = null;

export function registerVersioningEditorSource(
  source: VersioningEditorSource,
): void {
  versioningEditorSource = source;
}

export function getVersioningEditorState(): VersioningEditorState | null {
  return versioningEditorSource ? versioningEditorSource() : null;
}
